import { render, staticRenderFns } from "./ListsEmptyPlaceholder.vue?vue&type=template&id=363cc89c&scoped=true"
import script from "./ListsEmptyPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListsEmptyPlaceholder.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListsEmptyPlaceholder.vue?vue&type=style&index=0&id=363cc89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363cc89c",
  null
  
)

export default component.exports